import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Divider, UnderLine } from './FomoWelcomeBonus';

function YoloCashbackSixerPromo (props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : (brandId == 46 || brandId == 47) ? "FUN88" : 'IW247';

    return (
        <>
            <InformationWrapper>
                <Container>
                </Container>
                <Container className='morePadding'>
                    <MainTitle className={brandId == 39 || brandId == 40 ? 'fomoTitle' : ''}>How to Participate</MainTitle>
                    <UnderLine></UnderLine>
                    <HowToImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.yoloCBSixHTP}`}
                            alt="How to Join"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </HowToImageWrapper>
                </Container>
                <TermsAndCondition className={!(brandId == 33 || brandId == 34) && 'bgRadial'}>
                    <MainTitle className={brandId == 39 || brandId == 40 ? 'fomoTitle' : ''}>Terms And Conditions:</MainTitle>
                    <ul>
                        <li>Minimum qualifying bet: ₹50 on Exchange only.</li>
                        <li>Cashback applies only if the mentioned event occurs <br />in at least one innings of the match.</li>
                        <li>Maximum cashback: ₹50 per player per day.</li>
                        <li>Valid only during Asia Cup (Sep 9 - 25, 2025).</li>
                        <li>Cashback will be credited within 24 hours..</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(YoloCashbackSixerPromo));

// Styled Component.
const HowToImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin: auto;
    margin-top: 2em;

    img {
        width: 100%;
        /* max-width: 100%; */
    }
`;
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 0rem 0;
    margin: 0em 1.2em 1.2em 1.2em;
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.yoloCBSixInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    border: 1px solid #bfbfbf;

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .footerText {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 120% */
        text-transform: capitalize;
        margin: 10px 0px 0px 0px;
    }

    .bgRadial {
        /* background: radial-gradient(38.26% 45.18% at 50% 0%, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 100%); */
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }

    .fomoTitle {
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 115.57%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
`;


const Container = styled.div`
    width: 100%;
    max-width: 1366px;
    height: 40vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin: 0 auto;

    &.morePadding {
        padding-top: 5rem;
        padding-bottom: 3rem;
    }
`;

const MainTitle = styled.h4`
    color: #FFF600;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    margin: 3px 0px 10px 0px;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
`

const TermsAndCondition = styled.div`
    width: 100%;
    max-width: 1010px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    padding-top: 3rem;

    & li {
        color: #FFF;
        text-align: justify;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 116.667% */
        text-transform: capitalize;
        list-style-type: decimal;
        padding-bottom: 1.5rem;
    }

    /* & h4 {
        background: linear-gradient(91deg, #D2D2D2 2.89%, #FFF 52.11%, #C8C8C8 99.8%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;

        :after {
            content: "";
            width: 107px;
            height: 3px;
            display: flex;
            margin: 0 auto;
            margin-top: 1rem;
            background: linear-gradient(91deg, #DBDBDB 2.89%, #FFF 52.11%, #CACACA 99.8%);
        }
    } */
`;